<template>
  <div :class="componentClassName">
    <span class="o-push-segment-type__required-icon">●</span>
    <span class="o-push-segment-type__label">セグメント設定方法</span>

    <div class="o-push-segment-type__radios">
      <label
        :class="['o-push-segment-type__radio-item', { 'is-checked': modelValue === 'selection', 'is-disabled': disabled }]">
        <input
          :id="id + '-selection'"
          type="radio"
          name="pushSegmentType"
          value="selection"
          :checked="modelValue === 'selection'"
          :disabled="disabled"
          :data-testid="dataTestid + '-selection'"
          class="o-push-segment-type__input"
          @change="handleRadioChange('selection')" />
        <div class="o-push-segment-type__indicator"></div>
        <span class="o-push-segment-type__radio-text">選択式</span>
      </label>

      <label
        :class="['o-push-segment-type__radio-item', { 'is-checked': modelValue === 'csv', 'is-disabled': disabled }]">
        <input
          :id="id + '-csv'"
          type="radio"
          name="pushSegmentType"
          value="csv"
          :checked="modelValue === 'csv'"
          :disabled="disabled"
          :data-testid="dataTestid + '-csv'"
          class="o-push-segment-type__input"
          @change="handleRadioChange('csv')" />
        <div class="o-push-segment-type__indicator"></div>
        <span class="o-push-segment-type__radio-text">CSV入力形式</span>
      </label>
    </div>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';

export default {
  name: 'o-push-segment-type',
  props: {
    id: {
      type: String,
      default: 'o-push-segment-type',
    },
    class: {
      type: String,
      default: '',
    },
    modelValue: {
      type: String,
      default: 'selection',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dataTestid: {
      type: String,
      default: 'push-segment-type',
    },
  },
  emits: ['update:modelValue', 'change'],
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers(
        'o-push-segment-type',
        this.disabled ? 'disabled' : ''
      );
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  methods: {
    handleRadioChange(value) {
      if (this.disabled) return;
      this.$emit('update:modelValue', value);
      this.$emit('change', value);
    },
  },
};
</script>
